import { Button } from '@casumo/dojo-react';
import { memo } from 'react';
import useMarketInfo from '../../hooks/useMarketInfo.tsx';
import { useRegistrationStore } from '../../store/store.ts';
import { TEST_ID } from '../../utils/constants';
import { FLOW_NAMES } from '../../utils/countries.ts';
import { GtmEvents } from '../../utils/gtm/gtm.ts';
import { DepositLimitOptInChoice } from '../depositLimits/depositLimitsWrapper.tsx';

type TDepositLimitsButton = {
  disabled?: boolean;
  label?: string;
  gtmPayload?: Record<string, string>;
  handleNext: ({ gtmPayload, redirectTo, canProceed }: {
    gtmPayload?: Record<string, string>;
    redirectTo?: string;
    canProceed?: boolean;
  }) => void;
}

const DepositButton = ({ label, disabled = false, gtmPayload, handleNext }: TDepositLimitsButton) => {
  const { metadata, setMetadata, formData } = useRegistrationStore();
  const { flowName } = useMarketInfo();
  const isPnpFlow = flowName === FLOW_NAMES.MGA_GRA_PNP;

  const canProceed = !(metadata?.depositLimitChoice === DepositLimitOptInChoice.SET_LIMIT
    && metadata.depositType);

  return (
    <Button
      disabled={disabled}
      width="full"
      className="disabled:text-grey-20"
      onClick={() => {
        if (canProceed) {
          setMetadata({ depositType: undefined, limitType: undefined, depositLimitDefined: false });
          GtmEvents.logDepositLimits(false);
        } else if (formData?.[metadata.depositType]) {
          GtmEvents.logDepositLimits(true, metadata.limitType);
        }
        handleNext?.({
          gtmPayload,
          redirectTo: '1',
          canProceed,
        })
      }}
      data-testid={TEST_ID.BUTTON_PRIMARY}
    >

      {
        metadata?.depositLimitChoice === DepositLimitOptInChoice.SET_LIMIT
        && metadata.depositType
          ? (isPnpFlow ? 'Rajasi' : 'Set limits')
          : label
      }
    </Button>
  )
};

const Memoized = memo(DepositButton);
Memoized.displayName = 'DepositButton';

export default Memoized;
